import { httpBus } from "@/api/index.js";

/**
 * 数据分析/电压一致性/电压一致性
 * @param {*} param0 
 * @returns 
 */
export function consistencyAnalysis({ startTime, endTime, stationId, eBlockId }) {
  return httpBus.request("get", `/dashboard/dataAnalysis/queryVoltageBalaningFromTAOS`, {
    params: {
      startTime, 
      endTime, 
      stationId: String(stationId), 
      equipmentUUID: eBlockId
    },
  });
}


/**
 * eBlock压差对比
 * @param {*} param0 
 * @returns 
 */
export function voltageDifference({ startTime, endTime, stationId, eLinkId }) {
  return httpBus.request("get", `dashboard/dataAnalysis/voltage/difference`, {
    params: {
      startTime, 
      endTime, 
      stationId: String(stationId), 
      eLinkId
    },
  });
}


/**
 * 电芯电压曲线
 * @param {*} param0 
 * @returns 
 */
export function queryBatteryVoltage({ startTime, endTime, stationId, eBlockId }) {
  return httpBus.request("get", `/dashboard/dataAnalysis/voltage/battery`, {
    params: {
      startTime, 
      endTime, 
      stationId: String(stationId), 
      equipmentUUID: eBlockId
    },
  });
}


/**
 * 方阵三相电压曲线
 * @param {*} param0 
 * @returns 
 */
export function queryELinkThreePhaseVoltage({ startTime, endTime, stationId, eLinkId }) {
  return httpBus.request("get", `/dashboard/dataAnalysis/queryELinkThreePhaseVoltage`, {
    params: {
      startTime, 
      endTime, 
      stationId: String(stationId), 
      equipmentUUID: eLinkId
    },
  });
}


/**
 * 获取电站所有电表的三项电压曲线数据
 * @param {*} param0 
 * @returns 
 */
export function queryMetersThreePhaseVoltage({ startTime, endTime, stationId }) {
  return httpBus.request("get", `/dashboard/dataAnalysis/queryMeterPhaseVoltage`, {
    params: {
      startTime, 
      endTime, 
      stationId: String(stationId), 
    },
  });
}



